// extracted by mini-css-extract-plugin
export var LayoutContainer = "LayoutContainer-module--LayoutContainer--ad715";